export const BENEFIT_EFFECTIVE_WINDOW_UPCOMING = 'UPCOMING'
export const BENEFIT_EFFECTIVE_WINDOW_WITHIN = 'CURRENT'
export const BENEFIT_EFFECTIVE_WINDOW_AFTER = 'ENDED'

export default {
  BENEFIT_EFFECTIVE_WINDOW_AFTER,
  BENEFIT_EFFECTIVE_WINDOW_UPCOMING,
  BENEFIT_EFFECTIVE_WINDOW_WITHIN,
}
